import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminCompanies from './pages/AdminCompanies';
import AdminPurchases from './pages/AdminPurchases';
import UserDashboard from './pages/UserDashboard';
import AdminUsers from './pages/AdminUsers';
import AboutPage from './pages/AboutPage';
import ServiceLevelAgreement from './pages/ServiceLevelAgreement';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Signup from './pages/Signup';
import CompanyAdminDashboard from './pages/CompanyAdminDashboard';
import PricingPage from './pages/PricingPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* ── Public ── */}
          <Route path="/"                      element={<HomePage />} />
          <Route path="/about"                 element={<AboutPage />} />
          <Route path="/contact"               element={<ContactPage />} />
          <Route path="/admin/login"           element={<AdminLogin />} />
          <Route path="/ServiceLevelAgreement" element={<ServiceLevelAgreement />} />
          <Route path="/privacy-policy"        element={<PrivacyPolicy />} />
          <Route path="/TermsOfService"        element={<TermsOfService />} />
          <Route path="/forgot-password"       element={<ForgotPassword />} />
          <Route path="/reset-password"        element={<ResetPassword />} />
          <Route path="/signup"                element={<Signup />} />
          <Route path="/pricing"               element={<PricingPage />} />

          {/* ── Super admin only ── */}
          <Route path="/admin/dashboard"
            element={<ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>}
          />
          <Route path="/admin/companies"
            element={<ProtectedRoute requiredRole="admin"><AdminCompanies /></ProtectedRoute>}
          />
          <Route path="/admin/purchases"
            element={<ProtectedRoute requiredRole="admin"><AdminPurchases /></ProtectedRoute>}
          />
          <Route path="/admin/users"
            element={<ProtectedRoute requiredRole="admin"><AdminUsers /></ProtectedRoute>}
          />

          {/* ── Company admin only ── */}
          <Route path="/company-admin/dashboard"
            element={<ProtectedRoute requiredRole="company_admin"><CompanyAdminDashboard /></ProtectedRoute>}
          />

          {/* ── Regular user ── */}
          <Route path="/dashboard"
            element={<ProtectedRoute requiredRole="user"><UserDashboard /></ProtectedRoute>}
          />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
